$(document).ready(function() {

  if ($(window).width() < 750) {
    $(".control-mobile").click(function(){
      if ($(this).hasClass('active')) {
        $(this).removeClass('active');
        $(this).next('.content-mobile').slideUp(500);
      }
      else {
        $(this).addClass('active');
        $(this).next('.content-mobile').slideDown(500);
      }
    });
  }

  // expand content
  $(".control-expand").click(function(){
    if ($(this).hasClass('active')) {
      $(this).removeClass('active');
      $(this).next('.expand-content').slideUp(500);
    }
    else {
      $(this).addClass('active');
      $(this).next('.expand-content').slideDown(500);
    }
  });
  // end expand content

  // scroll to top button
  $(window).scroll(function() {
    if ($(window).scrollTop() > 100) {
      $('.footer-button-scroll-top').css({"opacity": "1", "visibility": "visible"});
    }
    else {
      $('.footer-button-scroll-top').css({"opacity": "0", "visibility": "hidden"});
    }
  })

  $(".footer-button-scroll-top, .button-scroll-top").click(function(){
    $("html, body").animate({ scrollTop: 0 }, "slow");
    return false;
  });
  // end scroll to top button

  // scroll to element
  $('a[href^="#"]').on('click', function (e) {
    e.preventDefault();

    var target = $($(this).attr('href'));

    if (target.length) {
      $('html, body').animate({
        scrollTop: target.offset().top
      }, 600);
    }
  });

  // end scroll to element

  // keep the scroll position when the menu drawer closes
  // Dawn returns focus to the drawer's summary when it closes (removeTrapFocus
  // calls elementToFocus.focus()). That summary sits in the header, which is not
  // sticky in this theme, so once the page has been scrolled the browser scrolls
  // the off-screen summary back into view and the page jumps to the top.
  //
  // Focusing with preventScroll keeps the focus return — needed for keyboard use
  // — without the scroll. Applied only to this one element, so focus handling for
  // the cart drawer, modals and predictive search is untouched.
  function preventMenuSummaryFocusScroll() {
    $('header-drawer > details > summary').each(function () {
      var summary = this;

      // Guard against wrapping twice if the header is re-rendered.
      if (summary.dataset.focusScrollPatched) return;
      summary.dataset.focusScrollPatched = 'true';

      var nativeFocus = summary.focus.bind(summary);

      summary.focus = function (options) {
        nativeFocus($.extend({}, options, { preventScroll: true }));
      };
    });
  }

  preventMenuSummaryFocusScroll();

  // The theme editor re-renders sections on every change, which replaces the
  // header and its summary, so the patch is reapplied.
  $(document).on('shopify:section:load', preventMenuSummaryFocusScroll);
  // end keep the scroll position when the menu drawer closes

  // mobile menu drawer close button
  // Below 750px the drawer is a fixed viewport overlay, so the summary that opens
  // it can be scrolled out of view. The drawer's own close button clicks that
  // summary rather than closing the drawer directly, so Dawn's HeaderDrawer keeps
  // ownership of closing: returning focus, resetting aria-expanded, and removing
  // the body class that locks background scrolling.
  $(document).on('click', '[data-menu-drawer-close]', function () {
    var summary = $(this).closest('header-drawer').find('summary').first();

    if (summary.length) {
      summary.trigger('click');
    }
  });
  // end mobile menu drawer close button

});